import React from 'react';
import { ThemeProvider } from './contexts/ThemeContext';

// Components
import Navbar from './Components/Navbar';
import About from './Components/About';
import Experience from './Components/Experience';
import Skills from './Components/Skills';
import Projects from './Components/Projects';
import Certificates from './Components/Certificates';
import Contact from './Components/Contact';

// Global CSS
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <div className="portfolio-app">
        <Navbar />
        <main className="main-content">
          <About />
          <Experience />
          <Skills />
          <Projects />
          <Certificates />
          <Contact />
        </main>
        
        {/* Copyright Footer */}
        <footer className="copyright-footer">
          <div className="copyright-content">
            <p>&copy; {new Date().getFullYear()} Venkata Phani Charan Udumula. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </ThemeProvider>
  );
}

export default App;
